/**
 * Simple view persistence utility
 * Saves and restores the current active tab so users don't lose their place on refresh
 */

const VIEW_STATE_KEY = 's3lion_current_view';

export const saveCurrentView = (activeTab) => {
  try {
    const viewState = {
      activeTab,
      timestamp: Date.now()
    };
    localStorage.setItem(VIEW_STATE_KEY, JSON.stringify(viewState));
  } catch (error) {
    console.warn('Failed to save view state:', error);
  }
};

export const restoreCurrentView = () => {
  try {
    const stored = localStorage.getItem(VIEW_STATE_KEY);
    if (!stored) return null;

    const viewState = JSON.parse(stored);
    
    // Check if state is recent (within last 2 hours)
    const hoursSinceStored = (Date.now() - viewState.timestamp) / (1000 * 60 * 60);
    if (hoursSinceStored > 2) {
      // Clear old state
      localStorage.removeItem(VIEW_STATE_KEY);
      return null;
    }

    return viewState.activeTab;
  } catch (error) {
    console.warn('Failed to restore view state:', error);
    return null;
  }
};

export const clearViewState = () => {
  try {
    localStorage.removeItem(VIEW_STATE_KEY);
  } catch (error) {
    console.warn('Failed to clear view state:', error);
  }
};